import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LandingPage from './_pages/LandingPage';
import InvitationDesignerStandalone from './_pages/InvitationDesignerStandalone';
import InvitationDesignerStandaloneV2 from './_pages/InvitationDesignerStandaloneV2';
import InvitationDesignerOnboarding from './_pages/InvitationDesignerOnboarding';
import PublicInvitationV2 from './_pages/invitations/PublicInvitationV2';
import EventHomepage from './_pages/event/EventHomepage';
import InvitationTypes from './_pages/invitations/InvitationTypes';
import ProtectedRoute from './_components/ProtectedRoute/ProtectedRoute';
import PrivacyPolicy from './_pages/PrivacyPolicy';
import TermsOfService from './_pages/TermsOfService';
import About from './_pages/About';
import PricingPage from './_pages/PricingPage';
import TemplateGallery from './_pages/TemplateGallery';
import ProofSheet from './_pages/ProofSheet';
import RenderTarget from './_pages/RenderTarget';
import PaymentSuccess from './_pages/billing/PaymentSuccess';
import { AuthProvider } from './_components/AuthProvider';

const Router: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
        {/* Landing Page */}
        <Route path="/" element={<LandingPage />} />

        {/* Template contact sheet — every registered design, rendered through
            the real preview component. Unprotected because it shows no data. */}
        <Route path="/gallery" element={<TemplateGallery />} />

        {/* Proof sheet — one unguessable link a customer opens to browse the
            designs an agent drew for them. Unauthenticated by design: the link
            IS the credential, and it reads a static JSON file, no API. */}
        <Route path="/proof/:id" element={<ProofSheet />} />

        {/* The render target a headless browser drives — cards at design size,
            unscaled, with a control surface on `window`. See scripts/render.mjs
            and src/_render/measure.ts. */}
        <Route path="/render" element={<RenderTarget />} />

        {/* Onboarding Route - No auth required */}
        <Route path="/design" element={<InvitationDesignerOnboarding />} />
        
        {/* Billing success route - Temporarily unprotected for testing */}
        <Route path="/app/billing/success" element={
          <div className="flex min-h-screen bg-gray-50">
            <div className="flex-1 flex flex-col min-w-0">
              <PaymentSuccess />
            </div>
          </div>
        } />
        
        {/* Admin Routes - Protected */}
        <Route path="/app/*" element={
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        } />
        <Route path="/designer" element={
          <ProtectedRoute>
            <InvitationDesignerStandalone />
          </ProtectedRoute>
        } />
        <Route path="/designer-v1" element={
          <ProtectedRoute>
            <InvitationDesignerStandalone />
          </ProtectedRoute>
        } />
        <Route path="/designer-v2" element={
          <ProtectedRoute>
            <InvitationDesignerStandaloneV2 />
          </ProtectedRoute>
        } />
        <Route path="/invitation-types" element={
          <ProtectedRoute>
            <InvitationTypes />
          </ProtectedRoute>
        } />
        
        {/* Public Routes - No authentication required */}
        <Route path="/invitations/:eventCode/:token" element={<PublicInvitationV2 />} />
        <Route path="/invitations/:eventCode/:token/:guestNames" element={<PublicInvitationV2 />} />
        <Route path="/event/:eventCode/:token/:eventName" element={<EventHomepage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Router;